export default __webpack_public_path__ + "static/media/helpfull_bg.338a4e29.jpg";